import { render, staticRenderFns } from "./deleteStaff.vue?vue&type=template&id=608952ba&"
import script from "./deleteStaff.vue?vue&type=script&lang=js&"
export * from "./deleteStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/deleteStaff.vue
// module id = 1359
// module chunks = 0